import { observable } from "mobx";
import lscache from "lscache";
import ProgramacaoService from "../../../services/ProgramacaoNaviosService";

export default class FiltrosVisualizacaoStore {

    @observable predefinicoes;
    @observable dadosTabelaAtivo;
    @observable situacoesAtivo;

    @observable predefinicaoAtiva;
    @observable mostrarLimiteDadosAtingido;
    @observable mostrarEditarPredefinicaoNome;

    @observable tabSelecionada;
    @observable filtrosVisualizacao;
    @observable filtrosAntigos;

    predefinicaoNomeAnterior;
    predefinicaoDescAnterior;
    qtdAtivos;
    filtrosAntigos;

    constructor() {
        this.programacaoService = new ProgramacaoService();


        {/* TODO: inserir esses campos especificos de filtros a partir da passagem de parametros no construtor */}
        this.dadosTabelaObrigatorios = ["F1", "F2", "F3", "F4"];
        this.dadosTabelaPadrao = ["F1", "F2", "F3", "F4", "F5", "F6", "F8", "F9", "F10", "F15"];

        this.todosDadosTabela = this.programacaoService.todosDadosTabela(!process.env.rig);

        this.todasSituacoes = ["Todos", "Programado", "Em espera", "Atracado", "Em operação", "Operado", "Fechado", "Cancelado"];
        this.situacoesPadrao = ["Todos"];

        // this.todasSituacoes = [{id: "F1", label: "Todos"}, {id: "F2", label: "Programado"}, {id: "F3", label: "Em espera"}, {id: "F4", label: "Atracado"}, {id: "F5", label: "Em operação"}, {id: "F6", label: "Operado"}, {id: "F7", label: "Fechado"}, {id: "F8", label: "Cancelado"}];
        // this.situacoesPadrao = ["F1"];

        this.dadosTabelaAtivo = [];
        this.situacoesAtivo = [];
        this.dadosGerais = { valor : "0", nome: "Padrão", descricao : ""};

        this.filtrosVisualizacao = [];
        this.filtrosAntigos = [];
        this.tabSelecionada = 0;

        this.carregarFiltros();

    }

    carregarFiltros(){
        if(lscache.get('access_token') || this.dadosTabelaAtivo.length === 0){

            this.programacaoService.buscarFiltrosVisualizacao().then(response => {
                if(response.data){
                    response.data.map(f => {
                        let fi = JSON.parse(f.ValorObjeto)
                        if (fi.dadosTabela.includes("Navio / Viagem")) {
                            f.ValorObjeto = "{\"valor\":0,\"nome\":\"Padrão\",\"descricao\":\"\",\"dadosTabela\":[\"F1\",\"F2\",\"F3\",\"F4\"],\"situacoes\":[\"Todos\"]}";
                        }
                    });
                }
    
                this.filtrosAntigos = response.data;
                this.filtrosVisualizacao = response.data;
    
                this.predefinicoes = new Array();
                
                if (this.filtrosVisualizacao.length) {
                    let colunas = JSON.parse(this.filtrosVisualizacao[this.tabSelecionada].ValorObjeto);
        
                    this.dadosTabelaAtivo = colunas.dadosTabela; // TODO rever
                    this.situacoesAtivo = colunas.situacoes ? colunas.situacoes : ["Todos"];
                    let x = 0;
                    this.filtrosVisualizacao.forEach(f => {
                        this.predefinicoes[x] = JSON.parse(f.ValorObjeto);//this.programacaoService.predefinicao;
                        x++;
                    });
                } else {
                    this.dadosTabelaAtivo = this.dadosTabelaObrigatorios; // TODO rever
                    this.situacoesAtivo = ["Todos"];
    
                    this.programacaoService.filtro.MembershipuserId = lscache.get('MembershipuserId');
    
                    this.filtrosVisualizacao[0] = this.programacaoService.filtro;
                    this.predefinicoes[0] = this.programacaoService.predefinicao;
                    this.filtrosVisualizacao[0].ValorObjeto = this.predefinicoes[0];
                    
                    this.filtrosVisualizacao[1] = this.programacaoService.filtro;
                    this.predefinicoes[1] = this.programacaoService.predefinicao;
                    this.filtrosVisualizacao[1].ValorObjeto = this.predefinicoes[1];
                    
                    this.filtrosVisualizacao[2] = this.programacaoService.filtro;
                    this.predefinicoes[2] = this.programacaoService.predefinicao;
                    this.filtrosVisualizacao[2].ValorObjeto = this.predefinicoes[2];
                }
    
                if(this.predefinicoes.indexOf(this.predefinicoes.find((elem) => elem.valor === 1)) === -1){
                    this.predefinicaoAtiva = 0
                }else{
                    this.predefinicaoAtiva = this.predefinicoes.indexOf(this.predefinicoes.find((elem) => elem.valor === 1))
                }
                //this.predefinicoes.indexOf(this.predefinicoes.find((elem) => elem.valor === 1))
                this.mostrarLimiteDadosAtingido = false;
                this.mostrarEditarPredefinicaoNome = false;
    
                this.dadosTabelaAtivo = this.predefinicoes[this.predefinicaoAtiva].dadosTabela;
                this.situacoesAtivo = this.predefinicoes[this.predefinicaoAtiva].situacoes ? this.predefinicoes[this.predefinicaoAtiva].situacoes : ["Todos"];
    
                this.calculaQtdAtivos();
            }).catch(error => {
                console.log(error);
            });

        }
    }

    predefinicaoClick = (index) => {
        this.predefinicoes.map((elem) => elem.valor = 0)
        //this.salvarFiltrosVisualizacao(this.filtrosVisualizacao[this.predefinicaoAtiva])
        this.predefinicaoAtiva = index;
        this.predefinicoes[this.predefinicaoAtiva].valor = 1
        this.dadosTabelaAtivo = this.predefinicoes[this.predefinicaoAtiva].dadosTabela;
        this.situacoesAtivo = this.predefinicoes[this.predefinicaoAtiva].situacoes ? this.predefinicoes[this.predefinicaoAtiva].situacoes : ["Todos"];
        
        this.calculaQtdAtivos();
        //this.salvarFiltrosVisualizacao();
    };

    calculaQtdAtivos = () => {
        this.qtdAtivos = this.dadosTabelaAtivo.length;
    };

    clickCheckboxLabel = (index) => {
        let indexCheckTabela = this.dadosTabelaAtivo.indexOf(this.dadosTabelaAtivo.find((item) => item === index.id));
        if (indexCheckTabela !== -1) {
            this.dadosTabelaAtivo = this.dadosTabelaAtivo.filter((value, i) => i !== indexCheckTabela);
        } else {
            if(this.qtdAtivos < 10 && this.qtdAtivos > 1){
                this.dadosTabelaAtivo.push(index.id)
            }else if(this.qtdAtivos <= 1){
                this.mostrarLimiteDadosAtingido = true
            }else{
                this.mostrarLimiteDadosAtingido = true
            }
        }
        this.predefinicoes[this.predefinicaoAtiva].dadosTabela = this.dadosTabelaAtivo;

        this.calculaQtdAtivos();
        //this.salvarFiltrosVisualizacao();
    };

    situacaoClick = (index) => {
        /** Quando o botão 'Todos' é marcado */
        if (index.toLowerCase() === "todos") {
            this.situacoesAtivo = [index];
            this.predefinicoes[this.predefinicaoAtiva].situacoes = this.situacoesAtivo;
            delete this.predefinicoes[this.predefinicaoAtiva].situacoes
        } else {

            let indexTodos = this.situacoesAtivo.indexOf("Todos");
            if(indexTodos !== -1){
                this.situacoesAtivo = [this.situacoesAtivo]
                this.situacoesAtivo.splice(indexTodos, 1);
            }

            let indexOption = this.situacoesAtivo.indexOf(index);
            if (indexOption !== -1) {
                this.situacoesAtivo = this.situacoesAtivo.filter((value, i) => i !== indexOption);
            } else {
                this.situacoesAtivo.push(index);
            }
            this.predefinicoes[this.predefinicaoAtiva].situacoes = this.situacoesAtivo;
        }

        //this.salvarFiltrosVisualizacao();
    };

    sairLimiteDadosAtingido = () => { this.mostrarLimiteDadosAtingido = false };

    editarPredeficaoNomeClick = () => {
        this.predefinicaoNomeAnterior = this.predefinicoes[this.predefinicaoAtiva].nome;
        this.predefinicaoDescAnterior = this.predefinicoes[this.predefinicaoAtiva].descricao;
        this.mostrarEditarPredefinicaoNome = true;
    };

    salvarNovoNome = () => {
        this.mostrarEditarPredefinicaoNome = false;
        //this.salvarFiltrosVisualizacao();
    };

    mudarNomePred = (e) => { this.predefinicoes[this.predefinicaoAtiva].nome = e.target.value };

    mudarDescPred = (e) => { this.predefinicoes[this.predefinicaoAtiva].descricao = e.target.value };

    cancelarNovoNome = () => {
        this.predefinicoes[this.predefinicaoAtiva].nome = this.predefinicaoNomeAnterior;
        this.predefinicoes[this.predefinicaoAtiva].descricao = this.predefinicaoDescAnterior;
        this.mostrarEditarPredefinicaoNome = false;
    };

    limparDadosTabela = () => {
        this.dadosTabelaAtivo = this.dadosTabelaObrigatorios
        this.predefinicoes[this.predefinicaoAtiva].dadosTabela = this.dadosTabelaAtivo;
        this.calculaQtdAtivos()
    }

    salvarFiltrosVisualizacao = () => {

        if(lscache.get('access_token')){
            this.insereObrigatorios() //para voltar a configuração sem adicionar os campos obrigatórios basta comentar esta parte
    
            this.filtrosVisualizacao.map((elem, index) => {
    
                elem.NomeObjeto = "" // Contornando bug vindo do serviço -- da erro se for null
    
                if(index === this.predefinicaoAtiva){
                    this.predefinicoes[index].valor = 1
                }else{
                    this.predefinicoes[index].valor = 0
    
                }
    
                elem.ValorObjeto = JSON.stringify(this.predefinicoes[index])
                this.programacaoService.salvarFiltrosVisualizacao(elem)
                    // .then(data => console.log(data))
                    // .catch(err => console.log(err))
            })
    
            this.carregarFiltros()
        }
        
    };

    insereObrigatorios(){
        let data = [...this.predefinicoes[this.predefinicaoAtiva].dadosTabela]
        this.dadosTabelaObrigatorios.forEach((elem) => {
            data.indexOf(elem) === -1 && data.push(elem)
        })
        this.predefinicoes[this.predefinicaoAtiva].dadosTabela = data
    }

    isAtivo(val, arr){
        return arr.indexOf(val)!==-1;
    }

    cancelarClick(){
        this.filtrosVisualizacao = this.filtrosAntigos
        this.carregarFiltros()
    }
}


// WEBPACK FOOTER //
// ./src/modules/programacao/stores/FiltrosVisualizacaoStore.js